import { GET_ALL_EMPLOYEES_SUCCESS, GET_ALL_EMPLOYEES_FAIL, LOGOUT, GET_ALL_EMPLOYEES_REQUEST } from "../actions/types";

const initialState = { employees: null, loading: false, error: null };

export const getAllEmployeesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_EMPLOYEES_REQUEST:
      return {
        ...state,

        employees: null,
        loading: true,
      };
    case GET_ALL_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: payload,
        loading: false,
      };
    case GET_ALL_EMPLOYEES_FAIL:
      return {
        ...state,
        employees: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     employees: false,
    //     user: null,
    //   };
    default:
      return state;
  }
};
